import React, { useState } from 'react';
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';

import Podcast from "./podcast/Podcast";

import logo from '../../assets/frontend/images/logo.png';
import podcast_icon_image from '../../assets/frontend/images/podcast_icon.png';
import feliz_podcast_image from '../../assets/frontend/images/feliz_podcast.jpg';

const resources = [
	{
		id: "sharing-rss",
		title: "Sharing Your Miraculous Life Podcast",
		type: "url",
		url: "https://anchor.fm/s/eff13fac/podcast/rss",
	},
	{
		id: "feliz-lltw-rss",
		title: "Feliz and Love Leads the Way Podcast",
		type: "url",
		url: "https://anchor.fm/s/10fcd1a1c/podcast/rss",
	},
];

const Podcasts = () => {

	const { id } = useParams();

	var resource = null;
	if (id && id !== '' && (id === 'sharing-rss' || id === 'feliz-lltw-rss')) {
		resource = resources.find(r => r.id === id);
	}

	//logout should be its own component
	const navHistory = useNavigate();

	const [resourceSelected, setResourceSelected] = useState(resource);
	const [showDescription, setShowDescription] = useState(false);

	const handleClick = (resource) => {
		if (resource.id === "sharing-rss" || resource.id === "feliz-lltw-rss") {
			setResourceSelected(resource);
		}
	};

	function toggleDescription() {
		setShowDescription(previous => !previous);
	}

	return (
		<div className="body-content bg-fff pt-80l-70m-60s pb-120">

			<div className="panel large ptb-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-libre-baskerville font-size-24l-20m-16s font-weight-800 bb1-555 pb-5">Podcasts</div>
					</div>
				</div>
			</div>

			<div className="panel large">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-center">
						<table>
							<tbody className="b1-ccc">
								{resources.map((resource, index) => (
									<tr key={index}>
										<td className="font-libre-baskerville font-size-18l-16m font-weight-400 text-left">{resource.title}</td>
										<td className="font-libre-baskerville font-size-18l-16m font-weight-400 text-right">
											<Link onClick={() => handleClick(resource)}>Listen</Link>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{resourceSelected ? (
				<div className="panel large">
					<div className="grid-x bg-555 p-20l-10s">

						<div className="large-4 medium-4 small-12 cell text-center pr-10l-0s">
							<div className="font-raleway font-size-24l-20m-18s text-000 text-center line-height-125per">
								<img src={feliz_podcast_image} alt="Feliz Garcia" className="img-responsive b5-fff" />
							</div>

							<div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-fff text-justify line-height-125per pt-20l-10s">
								About Podcast
							</div>
							<div className="font-raleway font-size-20l-18m-16s txt-fff text-justify line-height-125per pt-20l-10s">
								My vision is to build a community of Love, Light, Spirituality, Joy, Purpose, and Happiness.
								My mission is to inspire personal transformation and create a heaven on earth through heartfelt conversations,&nbsp;
								{showDescription && (
									<span className="">
										powerful stories, and transformative insights. Join us each week as we explore the depths of what it means to
										live a fulfilled and enlightened life. Whether we're delving into spiritual practices, sharing personal triumphs,
										or discussing life's challenges, our podcast is a sanctuary for those seeking to infuse more love and positivity into their lives.
									</span>
								)
								}
								<div className="episode-description-toggle hover-opacity-50 font-raleway font-size-20l-18m-16s font-weight-600 txt-fff text-left line-height-125per pt-10"
									onClick={toggleDescription}>

									<span>
										{showDescription
											? "Read Less"
											: "Read More"
										}
									</span>

									<span className="episode-chevron pl-5">
										{showDescription
											? "▲"
											: "▼"
										}
									</span>
								</div>
							</div>
						</div>
						<div className="large-8 medium-8 small-12 cell text-center pl-10l-0s">
							<div className="pt-10 mt-10 bt1-ccc show-for-small-only">&nbsp;</div>
							<div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-fff text-center line-height-125per pb-20l-10s">
								{resourceSelected.title}
							</div>
							<Podcast resourceId={resourceSelected.id} />
						</div>

					</div>
				</div>
			) : (
				<div className="panel large">
					<div className="grid-x bg-555 p-20l-10s">

						<div className="large-4 medium-4 small-12 cell text-center pr-10l-0s">
							<div className="font-raleway font-size-24l-20m-18s text-000 text-center line-height-125per">
								<img src={feliz_podcast_image} alt="Feliz Garcia" className="img-responsive b5-fff" />
							</div>
						</div>

						<div className="large-8 medium-8 small-12 cell text-center pl-10l-0s">
							<div className="pt-10 show-for-small-only">&nbsp;</div>
							<div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-fff text-justify line-height-125per">
								About Podcast
							</div>
							<div className="font-raleway font-size-20l-18m-16s txt-fff text-justify line-height-125per pt-20l-10s">
								My vision is to build a community of Love, Light, Spirituality, Joy, Purpose, and Happiness.
								My mission is to inspire personal transformation and create a heaven on earth through heartfelt conversations,&nbsp;
								{showDescription && (
									<span className="">
										powerful stories, and transformative insights. Join us each week as we explore the depths of what it means to
										live a fulfilled and enlightened life. Whether we're delving into spiritual practices, sharing personal triumphs,
										or discussing life's challenges, our podcast is a sanctuary for those seeking to infuse more love and positivity into their lives.
									</span>
								)
								}
								<div className="episode-description-toggle hover-opacity-50 font-raleway font-size-20l-18m-16s font-weight-600 txt-fff text-left line-height-125per pt-10"
									onClick={toggleDescription}>

									<span>
										{showDescription
											? "Read Less"
											: "Read More"
										}
									</span>

									<span className="episode-chevron pl-5">
										{showDescription
											? "▲"
											: "▼"
										}
									</span>
								</div>
							</div>
						</div>

					</div>
				</div>
			)}

		</div>
	);
}

export default Podcasts;